export const legalData = {
    beneficiary: 'RC BLOCK SOLUTIONS LTD',
    regNumber: '14969798',
    address: '86-90 PAUL STREET, LONDON, ENGLAND, EC2A 4NE'
};
